import React from 'react';
import { STATUS_CONFIG, BADGE_COLORS } from './constants';
import { formatRelative } from './utils';
import { TagChipList } from './LeadTags';
import { LeadAvatar } from './LeadAvatar';

export const ChatListItem = ({ lead, onClick, isSelected }) => {
  const cfg = STATUS_CONFIG[lead.status] || STATUS_CONFIG.nuevo;
  const hasUnread = lead.unread_count > 0 || lead.has_unread_messages;
  const adBadge = lead.ad_badge;
  const adColor = adBadge ? (BADGE_COLORS[adBadge.color] || BADGE_COLORS.blue) : null;
  const lastTime = lead.last_interaction || lead.created_at;
  const relTime = formatRelative(lastTime);

  // Intentamos sacar un preview del último mensaje si existe en lead.last_message_text o similar
  const previewText = lead.last_message_text || lead.phone;

  return (
    <button
      type="button"
      onClick={() => onClick(lead)}
      data-testid={`chat-list-item-${lead.id}`}
      className={`group w-full flex items-center gap-3.5 px-3.5 py-3.5 text-left transition-colors cursor-pointer border-b border-slate-100/70 dark:border-slate-800/70 focus:outline-none focus-visible:bg-indigo-50 dark:focus-visible:bg-indigo-500/15 focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-indigo-400/50 dark:focus-visible:ring-indigo-400/50 ${isSelected ? 'bg-indigo-50/70 dark:bg-indigo-500/15' : 'hover:bg-slate-50/80 dark:hover:bg-slate-800/70'}`}
    >
      <LeadAvatar lead={lead} size="sm" ring={hasUnread} statusClass={cfg.dot} />
      <div className="flex-1 min-w-0 flex flex-col justify-center py-0.5">
        <div className="flex items-center justify-between gap-2">
          <span className={`min-w-0 truncate text-[14px] leading-tight ${hasUnread ? 'font-semibold text-slate-950 dark:text-slate-50' : 'font-medium text-slate-800 dark:text-slate-200'}`}>{lead.name || lead.phone}</span>
          <span className={`shrink-0 text-[10px] leading-none tabular-nums ${hasUnread ? 'font-semibold text-indigo-600 dark:text-indigo-300' : 'text-slate-400 dark:text-slate-500'}`}>{relTime}</span>
        </div>
        <div className="mt-1 flex min-w-0 items-center gap-2">
          <span className="min-w-0 flex-1 truncate text-[12px] leading-tight text-slate-500 dark:text-slate-400">
            {previewText}
          </span>
          {adBadge && (
            <span className={`inline-flex items-center gap-0.5 rounded-full border px-1.5 py-0.5 ${adColor.border} ${adColor.bg} text-[9px] font-semibold ${adColor.text} max-w-[70px] truncate shrink-0`}>
              📢 {adBadge.label}
            </span>
          )}
          {hasUnread && (
            <span className="inline-flex h-[18px] min-w-[18px] shrink-0 items-center justify-center rounded-full bg-indigo-600 px-1 text-[10px] font-bold text-white shadow-sm shadow-indigo-500/20">
              {lead.unread_count || 1}
            </span>
          )}
        </div>
        {Array.isArray(lead.tag_details) && lead.tag_details.length > 0 && (
          <div className="mt-1 flex min-w-0 opacity-90">
            <TagChipList tags={lead.tag_details} max={3} size="xs" />
          </div>
        )}
      </div>
    </button>
  );
};
